import { __assign, __makeTemplateObject, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import styled from 'styled-components';
import ListItem from '../ListItem';
import { useForkRef } from '../utils/withForwardedRef';
var ListElement = styled(ListItem).withConfig({
  displayName: "ui-kit-ListElement",
  componentId: "ui-kit-7o0eck"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 40px;\n  box-sizing: border-box;\n  overflow: hidden;\n  white-space: nowrap;\n  cursor: pointer;\n\n  &.focused:not(.disabled),\n  &:focus-visible:not(.disabled) {\n    box-shadow: 0px 0px 0px 3px ", ";\n  }\n\n  &.disabled {\n    cursor: default;\n    color: ", ";\n  }\n\n  &.submenu:not(.disabled) {\n    &:hover,\n    &.selected,\n    &:active {\n      background-color: ", ";\n    }\n  }\n\n  &:not(.submenu):not(.disabled) {\n    &.selected,\n    &:active {\n      color: ", ";\n      background-color: ", ";\n\n      .ui-list-item__left-icon {\n        color: inherit;\n      }\n    }\n\n    &:hover:not(.selected):not(:active) {\n      background-color: ", ";\n    }\n  }\n"], ["\n  height: 40px;\n  box-sizing: border-box;\n  overflow: hidden;\n  white-space: nowrap;\n  cursor: pointer;\n\n  &.focused:not(.disabled),\n  &:focus-visible:not(.disabled) {\n    box-shadow: 0px 0px 0px 3px ", ";\n  }\n\n  &.disabled {\n    cursor: default;\n    color: ", ";\n  }\n\n  &.submenu:not(.disabled) {\n    &:hover,\n    &.selected,\n    &:active {\n      background-color: ", ";\n    }\n  }\n\n  &:not(.submenu):not(.disabled) {\n    &.selected,\n    &:active {\n      color: ", ";\n      background-color: ", ";\n\n      .ui-list-item__left-icon {\n        color: inherit;\n      }\n    }\n\n    &:hover:not(.selected):not(:active) {\n      background-color: ", ";\n    }\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.primary.overlay32;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.label.inactive;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.primary.overlay8;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.label.accent;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.primary.overlay24;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.primary.overlay16;
});
var MenuItem = React.forwardRef(function (_a, ref) {
  var className = _a.className,
      _b = _a.selected,
      selected = _b === void 0 ? false : _b,
      _c = _a.autoScroll,
      autoScroll = _c === void 0 ? false : _c,
      _d = _a.focused,
      focused = _d === void 0 ? false : _d,
      paperRef = _a.paperRef,
      otherProps = __rest(_a, ["className", "selected", "autoScroll", "focused", "paperRef"]);

  var submenu = otherProps.submenu;
  var elementRef = React.useRef(null);

  var scroll = function scroll(element, scrollerElement, center) {
    if (center === void 0) {
      center = false;
    }

    if (!scrollerElement.scrollTo) {
      return;
    }

    var offsetTop = element.offsetTop;

    if (offsetTop > scrollerElement.offsetHeight + scrollerElement.scrollTop || offsetTop < scrollerElement.scrollTop) {
      var top_1 = center ? offsetTop - scrollerElement.offsetHeight / 2 : offsetTop;
      scrollerElement.scrollTo({
        top: top_1
      });
    }
  };

  React.useEffect(function () {
    if (autoScroll && elementRef.current && (paperRef === null || paperRef === void 0 ? void 0 : paperRef.current)) {
      scroll(elementRef.current, paperRef.current, true);
    }
  }, [autoScroll, paperRef]);
  React.useEffect(function () {
    if (focused && elementRef.current && (paperRef === null || paperRef === void 0 ? void 0 : paperRef.current)) {
      scroll(elementRef.current, paperRef.current);
    }
  }, [focused, paperRef]);
  var rootClassName = classnames(className, {
    selected: selected,
    focused: focused,
    submenu: submenu
  });
  return _jsx(ListElement, __assign({
    className: rootClassName,
    ref: useForkRef(ref, elementRef)
  }, otherProps));
});
export default React.memo(MenuItem);
var templateObject_1;